import React, { useRef, useLayoutEffect } from "react"
import NProgress from "nprogress"

let key = 0

const Progress = ({ status, children }) => {
    const id = useRef()
    const captured = useRef()
    if (!id.current) {
        id.current = `progress-${key}`
        key++
    }

    useLayoutEffect(() => {
        if (status) {
            captured.current = NProgress.settings.parent
            NProgress.configure({ parent: `#${id.current}` })
            NProgress.start()
        } else {
            NProgress.done()
            NProgress.configure({ parent: captured.current })
        }
    }, [status])
    useLayoutEffect(() => {
        return () => {
            if (captured.current) NProgress.configure({ parent: captured.current })
            if (NProgress.isStarted()) NProgress.done()
        }
    }, [])

    return <div id={id.current}>{children}</div>
}
export default Progress
